<script lang="ts">
	import Image from '$lib/storyblok/components/image.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage, SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLAnchorElement> {
		content: ISbStoryData<{
			logo: SbImage;
			link: SbLink;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<a use:editable={content} href={getSbUrl(content.link)} target={content.link.target}>
	<Image
		src={content.logo.filename}
		alt={content.logo.alt}
		title={content.logo.title}
		class="h-5 lg:h-6"
		height={20}
		sizes={{ 1024: { height: 24 } }}
	/>
</a>
